/**
 * ISO 27001 A.12.4.1 — Registro de eventos de segurança
 * Registra ações sensíveis na tabela audit_log do Supabase.
 * Falhas silenciosas: nunca bloquear a operação principal.
 */
import { supabase } from '../lib/supabase';

/**
 * Ações auditáveis.
 */
export const AUDIT_ACTIONS = {
  LOGIN:            'LOGIN',
  LOGOUT:           'LOGOUT',
  SESSION_TIMEOUT:  'SESSION_TIMEOUT',
  PASSWORD_CHANGE:  'PASSWORD_CHANGE',
  DATA_EXPORT:      'DATA_EXPORT',
  DATA_DELETE:      'DATA_DELETE',
  BACKUP_MANUAL:    'BACKUP_MANUAL',
  BACKUP_EMAIL:     'BACKUP_EMAIL',
};

/**
 * Registra um evento de auditoria.
 * @param {string} action  - Constante de AUDIT_ACTIONS
 * @param {string} resource - Módulo/recurso afetado (ex: 'financeiro')
 * @param {object} detail  - Dados extras sem PII sensível
 */
export async function registrarAuditoria(action, resource = null, detail = null) {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) return; // não autenticado, não registra

    await supabase.from('audit_log').insert({
      user_id:    session.user.id,
      user_email: session.user.email,
      action,
      resource,
      detail,
    });
  } catch {
    // falha silenciosa — nunca bloquear a operação principal
  }
}
